<template>
	<div class="pa-2">
		<div v-if="conversation.schedule">
			<div>
				<v-icon small class="mr-2">mdi-calendar</v-icon>
				<b>{{ conversation.schedule.vt_date | toDateTime }}</b>
			</div>
			<div>
				<div
					class="mt-1"
				>
					<v-chip
						:color="vtStatusColor"
						label
						outlined
						x-small
						class="mb-1 px-1 wrap-chip d-flex align-center flex-grow-1 justify-center"
					>
						{{ vtStatusText }}
					</v-chip>
				</div>
				<!-- <small><b>{{ conversation.schedule.status == 1 ? 'Esperando confirmación':'Confirmada' }}</b></small> -->
			</div>
			<div v-if="conversation.schedule && conversation.schedule.user_schedule && conversation.schedule.user_schedule.responsible && conversation.schedule.user_schedule.responsible.profile">
				<p class="caption mb-0 text--secondary"><small>Encargado Visita:</small></p>
				<div>
					<v-icon small class="mr-2">mdi-account-check-outline</v-icon>
					<b>{{ conversation.schedule.user_schedule.responsible.profile.name + ' ' + conversation.schedule.user_schedule.responsible.profile.lastname + ' ' + conversation.schedule.user_schedule.responsible.profile.second_lastname }}</b>
					<v-menu
						v-model="assignMenu"
						offset-y
						z-index="9999"
						content-class="menu-bg-white"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								dark
								small
								icon
								color="#524D4D"
								@click="$emit('selectRow', conversation)"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
							</v-btn>
						</template>
						<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
							<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
								<p class="caption mb-0 font-weight-bold white--text">Cambiar Encargado VT</p>
							</v-list-item>
							<v-list-item-group color="#524D4D">
								<v-list-item
									v-for="(responsible, index) in $store.state.users.usersList"
									:key="index"
									dense
									@click.stop="handleAssign(conversation, responsible.id)"
								>
									<v-list-item-title dense>
										<div class="d-flex align-center">
											<img :src="responsible.profile.avatar" class="user-avatar mr-2" v-if="responsible?.profile?.avatar"/>
											<v-icon v-else class="user-avatar icon mr-2" color="#524D4D">mdi-account</v-icon>
											<div>
												<p class="mb-0">{{ responsible.profile?.name }} {{ responsible.profile?.lastname }} {{ responsible.profile?.second_lastname }}</p>
												<p class="mb-0 caption">{{ responsible.email }}</p>
											</div>
										</div>
									</v-list-item-title>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-menu>
				</div>
			</div>
		</div>
		<div v-else>
			<p class="mb-0 font-weight-bold" style="font-size: 10px;">Sin Agenda Configurada</p>
		</div>
		<v-divider class="my-1"></v-divider>
		<div v-if="conversation.report_budgets.length">
			<p class="mb-0 font-weight-bold" style="font-size: 10px;">Presupuesto Desarchivo ({{ conversation.report_budgets.length }})</p>
			<div class="mt-1">
				<v-chip
					:color="reportStatusColor"
					label
					outlined
					x-small
					class="d-flex align-center justify-center"
					style="height: auto;"
				>
					<div class="d-flex flex-column align-center justify-space-between py-1">
						<p class="mb-1" style="font-size: 12px;line-height: 12px;">{{ reportStatusText }}</p>
						<p class="mb-0 text-center" style="font-size: 11px;line-height: 10px;"><b>{{ lastReportBudget?.last_status?.created_at | toDateTime }}</b></p>
						<p class="mb-0 text-center" v-if="lastReportBudget?.budget?.payment_order" style="font-size: 11px;line-height: 10px;"><b>{{ lastReportBudget?.budget?.payment_order?.payment_info?.payment_date | toDateTime }}</b></p>
					</div>
				</v-chip>
			</div>
		</div>
		<div v-else>
			<p class="mb-0 font-weight-bold" style="font-size: 10px;">Sin Presupuesto Desarchivo</p>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {assignScheduleToUser} from '@/helpers/api/crm'

export default {
	name: 'ListingScheduleUnarchive',
	props: {
		conversation: {
			type: Object,
			required: true
		}
	},
	computed: {
		vtStatusText(){
			if ((!this.conversation.schedule?.closure || this.conversation.schedule.closure.length === 0) && moment().diff(moment(this.conversation.schedule.vt_date), 'hours') >= 24) {
				return 'Visita Técnica No Realizada'
			}
			else if(this.conversation.schedule.closure.length > 0){
				return 'Visita Técnica Realizada'
			}
			else if(this.conversation.schedule.status == 1){
				return 'Esperando confirmación / Pago'
			}
			return 'Confirmada Por Cliente / En espera de visita'
		},
		vtStatusColor(){
			if ((!this.conversation.schedule?.closure || this.conversation.schedule.closure.length === 0) && moment().diff(moment(this.conversation.schedule.vt_date), 'hours') >= 24) {
				return '#FF120B'
			}
			else if(this.conversation.schedule.closure.length > 0){
				return 'green'
			}
			else if(this.conversation.schedule.status == 1){
				return 'orange'
			}
			return 'orange'
		},
		reportStatusText(){
			const reportStatus = this.lastReportBudget.last_status?.status
			return this.$options.filters.budgetStatus(reportStatus)
		},
		reportStatusColor(){
			const reportStatus = this.lastReportBudget.last_status?.status
			return this.$options.filters.budgetStatusColor(reportStatus)
		},
		lastReportBudget(){
			const sorted = [...this.conversation.report_budgets].sort((a, b) => b.id - a.id);
			const last = sorted[0];
			return last
		},
	},
	data() {
		return {
			assignMenu: false
		}
	},
	methods: {
		async changeUserAssignation(item, new_user_id){
			await assignScheduleToUser({new_user_id, schedule_id: item.schedule.user_schedule.id})
			eventBus.$emit('reloadInformation')
		},
		handleAssign(conversation, userId) {
			this.$emit('selectRow', conversation)
			this.changeUserAssignation(conversation, userId)
			this.assignMenu = false
		}

	}
}
</script>

<style>

</style>